import React, { useEffect, useRef, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Apis } from "../util/Apis";
import PermissionDialog from "../components/permission";
import { BottomNav, Navbar } from "../components/blocks";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Resumen from "./Resumen";
import DepositarCupones from "./DepositarCupones";
import Sorteos from "./Sorteos";
import Promociones from "./Promociones";
import Notificaciones from "./Notificaciones";
import Perfil from "./Perfil";
import Cupones from "./Cupones";
import DetalleCupones from "./DetalleCupones";
import Puntos from "./Puntos";
import Anforas from "./Anforas";
import LectorQR from "./LectorQR";
import Recompensas from "./Recompensas";
import Cashless from "./Cashless";

const Main = () => {
  const { pathname } = useLocation();
  const scrollContainerRef = useRef(null);

  const { data: meData } = useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      const res = await axios.get(Apis.CAPP + "/me");
      return res.data;
    },
  });

  const shouldShowDialog = meData?.notificationsAccepted === null;
  const [isOpenDialog, setIsOpenDialog] = useState(shouldShowDialog);
  const togglePermission = () => {
    setIsOpenDialog((prev) => !prev);
  };

  useEffect(() => {
    scrollContainerRef.current?.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  
  return (
    <div
      ref={scrollContainerRef}
      className="w-full h-screen overflow-y-auto select-none bg-slate-100"
    >
      <PermissionDialog isOpen={isOpenDialog} toggle={togglePermission} setIsOpenDi={setIsOpenDialog}/>
      <Navbar meData={meData} />
      <div className="w-full px-4 pt-4 pb-[96px]">
        <Routes>
          <Route path="resumen" element={<Resumen />} name='Resumen'/>
          <Route path="puntos" element={<Puntos />} name='Puntos'/>
          <Route path="anforas" element={<Anforas/>} name="Anforas"/>
          <Route path="cashless" element={<Cashless/>} name="Cashless"/>
          <Route path="depositar-cupones/:id" element={<DepositarCupones/>}/>
          <Route path="sorteos" element={<Sorteos/>}/>
          <Route path="promociones" element={<Promociones/>}/>
          <Route path="notificaciones" element={<Notificaciones/>}/>
          <Route path="lector-qr" element={<LectorQR/>}/>
          <Route path='recompensas' element={<Recompensas/>}/>
          <Route path="perfil" element={<Perfil/>}/>
          <Route path="cupones" element={<Cupones/>}/>
          <Route path="home" element={<Resumen/>}/>
          <Route path="detalle-cupones/:id" element={<DetalleCupones/>}/>
          <Route path="" element={<Navigate to={'/home'}/>}/>
        </Routes>
      </div>
      <BottomNav />
    </div>
  )
}

export default Main;
